import axiosInstance from '../axiosInterceptor/axiosInstance'

const updateStage = async ({ orgId, stageId, data }) => {
  const url = `v1/orgs/${orgId}/stages/${stageId}`
  const response = await axiosInstance.patch(url, JSON.stringify(data))
  return response?.data
}

export default updateStage
